import Element, { ElementType } from '@/models/element';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';
import { BaseElementToSimpleSapElementMapper } from '../baseElementToSimpleSapElementMapper';
import store from '@/store';

export class BodyToSimpleSapElementMapper extends BaseElementToSimpleSapElementMapper {

    private color: string = '';

    public map(element: Element): ISimpleSapElement[] {
        this.color = this.toColor(element);
        const sides = this.getSides();
        const wreaths = this.getWreaths();
        // const back = this.getBack();
        return [sides, wreaths];
    }

    private getSides() {
        const type = this.formatType('ZEB', this.height, this.depth);
        return SimpleSapElement.ELEMENT(type, this.color);
    }

    private getWreaths() {
        const elements: Element[] = store.getters.scene.elements;
        const legs = elements.filter((x) => x.type === ElementType.LEGS);
        const hasLegs = legs.length > 0;
        const code = (!hasLegs && (this.depth === 2 || this.depth === 4))
            ? 'ZWW'
            : 'ZWS';
        const type = this.formatType(code, this.width, this.depth);
        return SimpleSapElement.ELEMENT(type, this.color);
    }
}
